import { createContext, useState } from 'react';

export const ImageContext = createContext();

export const ImageProvider = ({ children }: { children: null | Node }) => {
  const [image, setImage] = useState({});

  return (
    <ImageContext.Provider value={{ image, setImage }}>
      {children}
    </ImageContext.Provider>
  );
};
